export const apiUrls = {
  list: "/api/settings",
  logins: "/api/settings/logins",
  changePassword: "/api/settings/change-password",
};
